/**
 * Dynamic Greeting Script
 * Changes greeting based on time of day
 * 
 * Time periods:
 * - 06:00 - 17:59: "Bună ziua" (Good day)
 * - 18:00 - 05:59: "Bună seara" (Good evening)
 */

class DynamicGreeting {
    constructor() {
        this.greetings = {
            day: 'Bună ziua,',
            evening: 'Bună seara,'
        };
        
        this.init();
    }

    init() {
        // Wait for DOM to be ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.updateGreetings());
        } else {
            this.updateGreetings();
        }

        // Update every minute to handle time changes
        setInterval(() => this.updateGreetings(), 60000);
    }

    getCurrentGreeting() {
        const now = new Date();
        const hour = now.getHours();
        
        // 06:00 - 17:59 = Day
        // 18:00 - 05:59 = Evening
        if (hour >= 6 && hour < 18) {
            return this.greetings.day;
        } else {
            return this.greetings.evening;
        }
    }

    updateGreetings() {
        const greeting = this.getCurrentGreeting();
        
        // Update style2 greeting
        const style2Element = document.getElementById('dynamic-greeting');
        if (style2Element) {
            style2Element.textContent = greeting;
        }
        
        // Update style1 greeting
        const style1Element = document.getElementById('dynamic-greeting-style1');
        if (style1Element) {
            style1Element.textContent = greeting;
        }
    }
}

// Initialize the dynamic greeting
new DynamicGreeting();
